<template>
  <v-container class="height_100p" style="display: contents">
    <v-row class="height_100p" justify="center" align="center">
      <v-col cols="12" sm="12" md="10" lg="7" align-self="center">
        <v-card
          class="mb-12 mx-auto card-main-text"
          color="secondary"
          elevation="0"
        >
          <div class="round__logo__main">
            <div class="round__logo__sub">
              <img src="../../../public/logo.png" width="50px" height="50px" />
            </div>
          </div>
          <div class="card-main-text-second"></div>

          <v-sheet
            class="v-sheet--offset rounded-lg v-sheet-with-v-shape mx-auto pa-5"
            elevation="12"
            max-width="calc(100% - 65px)"
          >
            <v-card class="mx-auto rounded-lg" elevation="0">
              <v-card-text>
                <div class="m-auto">
                  <h2 class="text-center text-primary-color font-weight-bold">
                    {{ $t("loginScreen.twoFactorAuth") }}
                  </h2>
                  <br />
                  <form class="mb-4">
                    <div
                      class="m-auto position-relative"
                      style="max-width: 300px"
                    >
                      <v-otp-input
                        length="6"
                        v-model="otpEntered"
                        :disabled="isOTPVerified"
                        @input="$v.otpEntered.$touch()"
                        @blur="$v.otpEntered.$touch()"
                        :error-messages="otpErrors"
                        class="font-weight-bold"
                      ></v-otp-input>

                      <h6 class="text-dark" v-if="timerCount > 0">
                        OTP will expire in the next
                        <span class="font-weight-bold">{{ timerCount }}</span>
                        seconds
                      </h6>

                      <div
                        class="text-center d-flex justify-content-center align-items-baseline"
                        v-if="timerCount === 0"
                      >
                        <span class="text-dark">Didn't receive the OTP?</span>
                        <v-btn
                          depressed
                          class="text-capitalize"
                          color="primary"
                          @click="getOTPCode"
                          text
                          :loading="isOTPLoading"
                          >Resend OTP</v-btn
                        >
                      </div>

                      <v-overlay absolute :value="isOTPVerified">
                        <v-progress-circular
                          indeterminate
                          color="primary"
                        ></v-progress-circular>
                      </v-overlay>
                    </div>

                    <v-btn
                      depressed
                      block
                      color="primary"
                      @click="onOTPVerify"
                      class="btn-primary mt-4 text-capitalize"
                    >
                      Confirm OTP
                    </v-btn>

                    <div
                      class="text-dark mt-4 d-flex justify-content-center align-items-baseline"
                    >
                      <span>Back to</span>
                      <v-btn
                        depressed
                        class="text-capitalize text-primary-color p-2"
                        color="primary"
                        plain
                        @click="$router.push('/login')"
                      >
                        {{ $t("loginScreen.loginPage") }}?
                      </v-btn>
                    </div>
                  </form>
                </div>
              </v-card-text>
            </v-card>
          </v-sheet>
        </v-card>
        <loading
          :active="loader"
          :is-full-page="fullPage"
          :opacity="0.9"
          color="#ff6b00"
          :height="height"
          :width="width"
        />
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import { required } from "vuelidate/lib/validators";
import { mapGetters } from "vuex";
import alerts from "@/mixins/alerts";
import agentService from "@/services/agentService/AgentService.js";
export default {
  mixins: [alerts],
  name: "TwoFactorAuth",
  mounted() {
    this.getOTPCode();
  },
  data() {
    return {
      otpEntered: "",
      isOTPVerified: false,
      dismissSecs: 5,
      dismissCountDown: 0,
      showDismissibleAlert: false,
      // alertMsg: {
      //   status: false,
      //   text: "",
      //   timeout: 2000,
      //   color: "blue-grey",
      //   type: "success",
      // },
      isOTPEnable: false,
      timerCount: 0,
      isOTPLoading: false,
    };
  },
  validations: {
    otpEntered: {
      required,
    },
  },
  watch: {
    timerCount: {
      handler(value) {
        // console.log("isOTPEnable", this.isOTPEnable)
        if (value > 0 && this.isOTPEnable) {
          // Time interval to run every 1 sec.
          setTimeout(() => {
            // stop interval when time out reaches to zero.
            if (this.timerCount === 0) return;
            this.timerCount--;
          }, 1000);
        }
      },
      immediate: true, // This ensures the watcher is triggered upon creation
    },
  },
  computed: {
    otpErrors() {
      const errors = [];
      if (!this.$v.otpEntered.$dirty) return errors;
      !this.$v.otpEntered.required && errors.push("OTP is required");
      return errors;
    },
    ...mapGetters("Authentication", ["user_email"]),
  },
  methods: {
    returnState() {
      return process.env.NODE_ENV === "dev"
        ? "text-white-color primary text-center"
        : "text-primary-color";
    },
    async getOTPCode() {
      // alert('i am hitted')
      const user_email = sessionStorage.getItem("username");
      if (!user_email) return;
      console.log("user_email", user_email);
      this.isOTPLoading = true;
      try {
        const responseData = await agentService.getOTP(user_email);
        this.isOTPLoading = false;
        // console.log(`get_otp_2FA responseData: ${JSON.stringify(responseData)}`);
        if (responseData && responseData.data.success) {
          this.isOTPEnable = true;
          this.timerCount = 300;
          this.showAlertSuccess(responseData.data.message);
          // this.alertMsg.status = true;
          // this.alertMsg.text = responseData.data.message;
          // this.alertMsg.type = "success";
          // this.alertMsg.color = "green";
        } else {
          this.isOTPEnable = false;
          this.showAlertError(responseData.message);
          // this.alertMsg.status = true;
          // this.alertMsg.text = responseData.message;
          // this.alertMsg.type = "error";
          // this.alertMsg.color = "warning";
        }
      } catch (err) {
        this.isOTPLoading = false;
        this.isOTPEnable = false;
        this.showAlertError(err.message);
        // this.alertMsg.status = true;
        // this.alertMsg.text = err.message;
        // this.alertMsg.type = "error";
        // this.alertMsg.color = "warning";
      }
    },
    async onOTPVerify() {
      this.$v.$touch();
      if (this.$v.$invalid) {
        return;
      }
      const user_email = sessionStorage.getItem("username");
      if (!user_email) return;
      this.isOTPVerified = true;
      const userDeatils = {
        user_email: user_email,
        otp: this.otpEntered,
        user_type: process.env.VUE_APP_USER_TYPE,
      };
      try {
        const responseData = await agentService.verifyOTP(userDeatils);
        if (responseData.data.status_code === 200) {
          if (responseData.data.data[0].user_type) {
            sessionStorage.setItem(
              "user_type",
              responseData.data.data[0].user_type
            );
          }
          sessionStorage.setItem(
            "is_evolet_user",
            responseData.data.data[0].is_evolet_user
          );
          sessionStorage.setItem(
            "access_token",
            responseData.data.data[0].access_token
          );
          sessionStorage.setItem(
            "complete_registration",
            responseData.data.data[0].complete_registration
          );
          sessionStorage.setItem(
            "refresh_token",
            responseData.data.data[0].refresh_token
          );
          sessionStorage.setItem(
            "partner_id",
            responseData.data.data[0].partner_id
          );
          sessionStorage.setItem(
            "partner_type",
            responseData.data.data[0].partner_type
          );
          sessionStorage.setItem(
            "partner_country",
            JSON.stringify(responseData.data.data[0].partner_country)
          );
          this.$store.commit(
            "app/set_token",
            responseData.data.data[0].access_token
          );
          this.$store.commit(
            "complete_registration",
            responseData.data.data[0].complete_registration
          );
          this.isOTPEnable = false;
          this.isOTPVerified = false;
          this.showAlertSuccess(responseData.data.message);
          // this.alertMsg.status = true;
          // this.alertMsg.text = responseData.data.message;
          // this.alertMsg.type = "success";
          // this.alertMsg.color = "green";
          setTimeout(() => this.$router.push({ name: "Home" }), 500);
        } else {
          this.isOTPEnable = true;
          this.isOTPVerified = false;
          this.showAlertError(
            "OTP entered is not a valid. Try to enter the OTP again"
          );
          // this.alertMsg.status = true;
          // this.alertMsg.text =
          //   "OTP entered is not a valid. Try to enter the OTP again";
          // this.alertMsg.type = "error";
          // this.alertMsg.color = "warning";
        }
      } catch (err) {
        console.log("err", err);
        this.isOTPVerified = false;
        this.isOTPEnable = true;
        this.showAlertError("Something Went Wrong");
        // this.alertMsg.status = true;
        // this.alertMsg.text = "Something Went Wrong";
        // this.alertMsg.type = "error";
        // this.alertMsg.color = "warning";
      }
    },
  },
};
</script>
<style lang="scss" scoped>
@import "@/global.scss";
.lead {
  font-weight: 400;
  color: $txt;
}
.v-sheet--offset {
  bottom: -20px;
  top: 70px !important;
  position: relative;
}

.language-selection {
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.button#input-type__BV_toggle_ {
  font-size: 10px;
}
.forgot-link {
  margin-top: 26px;
  line-height: 3rem;
}

.shadow_class {
  box-shadow: 0 4px 4px rgba(0, 0, 0, 0.25);
  // width: %;
  background: #f8f9fa;
  border-radius: 7px;
}
</style>
